<template>
  <div v-if="isNavbarOpened" class="navbar-node" @click="handleClick">
    <div class="navbar-node__icon">
      <ChatBubbleBottomCenterTextIcon aria-hidden="true" />
    </div>
    <div class="navbar-node__label">{{ t('Need Help?') }}</div>
  </div>
  <UIButtonIcon
    v-else
    :label="t('Need Help?')"
    :leading="ChatBubbleBottomCenterTextIcon"
    variant="gray"
    fill="outlined"
    size="sm"
    class="navbar-item-menu"
    @click="handleClick"
  />
</template>

<script setup lang="ts">
import { inject, markRaw } from 'vue'

import { OpenedFlag } from '@types'

import { NAVBAR_OPENED } from '@/const'

import { useLocale } from '@/plugins/i18n'

import { useHubspot } from '@/plugins/hubspot'

import { useModalsStore } from '@/store/modals'

import HubspotUnavailableModal from '../../components/HubspotUnavailableModal.vue'

import { UIButtonIcon } from '@ui/buttons'
import { ChatBubbleBottomCenterTextIcon } from '@heroicons/vue/24/outline'

const { t } = useLocale('layouts.Main')

const hubspot = useHubspot()
const modalsStore = useModalsStore()

const isNavbarOpened = inject<OpenedFlag>(NAVBAR_OPENED)

const handleClick = () => {
  if (hubspot?.isLoaded) {
    hubspot.open()
  } else {
    const modalInstance = modalsStore.init(
      'hubspot-unavailable',
      markRaw(HubspotUnavailableModal)
    )
    modalInstance?.open(modalsStore.getZIndex())
  }
}
</script>
